export default __webpack_public_path__ + "static/img-app-leaderboard-854ddd7529d780dc1d803b6eeb8a6b79.webp";